<p *ngIf="!value">N/A</p>

<button
    *ngIf="value && !isDisabled && !value.restricted"
    mat-button
    class="px-0"
    [matMenuTriggerFor]="countriesMenu"
    (menuOpened)="onOpen()"
    #menuTrigger="matMenuTrigger"
    [class.active]="menuTrigger.menuOpen"
>
    <img alt="flag" src="/assets/images/flags_iso/24/{{ flagCodeByCountry(value) }}.png" />

    <span>{{ formatValue(value) }}</span>
    <mat-icon class="s-12 ml-4" svgIcon="dropdown" iconPositionEnd></mat-icon>
</button>

<button
    *ngIf="isDisabled || value?.restricted"
    mat-button
    class="px-0 disabled"
    [matTooltip]="disabled && disabledTooltip ? disabledTooltip : null"
>
    <img alt="flag" class="mr-8" src="/assets/images/flags_iso/24/{{ flagCodeByCountry(value) }}.png" />
    <span>{{ formatValue(value) }}</span>
    <mat-icon class="s-12 ml-4" svgIcon="dropdown" iconPositionEnd></mat-icon>
</button>

<mat-menu #countriesMenu="matMenu" overlapTrigger="false" class="u-dropdown theme-light small select-country-dropdown">
    <search-input-control
        size="small"
        (searchChange)="onSearchChange($event)"
        [focused]="true"
        [keepFocus]="true"
        [stopClickPropagation]="true"
        [value]="searchValue"
    >
    </search-input-control>

    <h5 *ngIf="!shownCountries.length" class="empty">No countries found</h5>

    <div
        class="items scrollable-container"
        #scrollBar
        perfectScrollbar
        [perfectScrollbarOptions]="{ suppressScrollX: true }"
    >
        <ng-template ngFor let-i="index" let-item [ngForOf]="shownCountries">
            <button
                mat-menu-item
                [ngClass]="{ disabled: item?.disabled }"
                *ngIf="!item.restricted"
                (click)="_select($event, item)"
                fxLayoutAlign="space-start center"
                matTooltip="{{ item?.disabled ? 'No data available for this country' : '' }}"
                [attr.tabindex]="i"
            >
                <img alt="flag" class="mr-8 mb-0" src="/assets/images/flags_iso/24/{{ flagCodeByCountry(item) }}.png" />
                <span>{{ item.title }}</span>
            </button>
        </ng-template>
    </div>
</mat-menu>
